import type { CSSProperties, FC, ReactNode } from 'react'
import type { BlobShape } from '@/lib/shapes'

import { cn } from '@/lib/utils'
import { SHAPES } from '@/lib/shapes'

interface BlobProps {
    shape: BlobShape
    className?: string
    style?: CSSProperties
}

// A decorative filled outline. Its color is the element's text color.
export const Blob: FC<BlobProps> = ({ shape, className, style }): ReactNode => {
    return (
        <svg
            viewBox='0 0 100 100'
            aria-hidden='true'
            focusable='false'
            className={cn('block', className)}
            style={style}
        >
            <path d={SHAPES[shape]} fill='currentColor' />
        </svg>
    )
}
